import { request } from '../utils/http'

// 界面配置方案相关接口

/**
 * 查询请求参数
 */
export interface DmnPerUiConfigQueryRequest {
  isPlatform?: boolean  // 是否平台级配置，默认false
  configName?: string
  configType: number  // 1-列表 2-表单
  configModule: number
}

/**
 * 保存请求参数
 */
export interface DmnPerUiConfigSaveRequest {
  isPlatform?: boolean  // 是否平台级配置，默认false
  configName: string
  configModule: number
  configType: number  // 1-列表 2-表单
  configContent: string  // JSON字符串
  isDefault?: boolean
  remark?: string
}

/**
 * 更新请求参数
 */
export interface DmnPerUiConfigUpdateRequest {
  id: string
  configName: string
  configContent: string  // JSON字符串
  isDefault?: boolean
  isPlatform?: boolean
  remark?: string
}

/**
 * 配置方案响应数据
 */
export interface DmnPerUiConfigVO {
  id: string
  tenantId: number
  configName: string
  configType: number
  configModule: number
  configBy: number
  configContent: string
  isDefault: boolean  // Boolean类型
  remark?: string
}

/**
 * 查询界面配置方案列表
 */
export const queryUiConfigList = (params: DmnPerUiConfigQueryRequest) => {
  console.log('🔧 [API调用] queryUiConfigList 参数:', params)
  return request.post<DmnPerUiConfigVO[]>('/sys/perUiConfig/queryList', params)
}

/**
 * 保存界面配置方案
 */
export const saveUiConfig = (params: DmnPerUiConfigSaveRequest) => {
  console.log('🔧 [API调用] saveUiConfig 参数:', params)
  return request.post<boolean>('/sys/perUiConfig/save', params)
}

/**
 * 更新界面配置方案
 */
export const updateUiConfig = (params: DmnPerUiConfigUpdateRequest) => {
  console.log('🔧 [API调用] updateUiConfig 参数:', params)
  return request.post<boolean>('/sys/perUiConfig/update', params)
}

/**
 * 删除界面配置方案
 */
export const deleteUiConfig = (id: string) => {
  return request.post<boolean>('/sys/perUiConfig/delete', { id, isPlatform: false })
}

// 导入模块枚举和相关函数
export { UiConfigModule, getModuleName, getModuleOptions } from '../enums/ui-config-module'

// 导入配置类型枚举和相关函数
export { UiConfigType, getConfigTypeName, getConfigTypeOptions } from '../enums/ui-config-type'
